// extracted by mini-css-extract-plugin
export default {"flakkiesCard":"Card_flakkiesCard__DBK5U","image":"Card_image__k0lJb","identification":"Card_identification__dNHHU"};